import React from "react";
import { EVENT_DATES, EVENT_LOCATION } from "../constants/eventDetails";

const CalendarSection = () => {
  const agendaHighlights = [
    "Opening Ceremony & Welcome Address",
    "Keynote Speeches by Global Industry Leaders",
    "Panel Discussions on Forex, FinTech & Trading Innovation",
    "Exhibition Booths & Product Showcases",
    "Networking & Business Meetings",
    "PROFX Awards Ceremony",
  ];

  return (
    <section className="py-5 calendar-section" style={{}}>
      <div className="container text-center">
        <h2 className="fw-bold mb-2 agenda-title">
          Agenda: <span className="gradient-text">Schedule TBA</span>
        </h2>
        <p className="text-grey mb-4">
          Curated tracks for every level will be announced soon. Venue:{" "}
          <strong className="text-white">{EVENT_LOCATION}</strong>.
        </p>

        <div className="calendar-wrapper shadow-sm p-3 rounded">
          <div className="row g-3 text-start">
            <div className="col-lg-4">
              <div className="bg-white h-100 p-4 rounded">
                <p className="mb-1 pink fw-semibold">Schedule</p>
                <h4 className="mb-0">{EVENT_DATES}</h4>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="bg-white h-100 p-4 rounded">
                <p className="mb-3 pink fw-semibold">Program Highlights</p>
                <ul className="m-0 ps-3">
                  {agendaHighlights.map((title) => (
                    <li className="mb-2" key={title}>
                      {title}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CalendarSection;
